import { interpolateHslLong, hsl } from 'd3';

export const hslInterpolator = interpolateHslLong(hsl(15, 1, 0.65), hsl(360+15, 1, 0.65));
